import script from "./CustomerEditModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerEditModal.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerEditModal.vue?vue&type=style&index=0&id=54170e4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54170e4c"]])

export default __exports__